import React from 'react';
import { FieldArray } from 'formik';

const FArray = ({ children }) => {
  return <FieldArray>{children}</FieldArray>;
};

export default FArray;
